import React from 'react';

export default () => (
  <div className="cup">
    <div className="cup__steam">
      <span className="cup__steam-item cup__steam-item--left" />
      <span className="cup__steam-item cup__steam-item--center" />
      <span className="cup__steam-item cup__steam-item--right" />
    </div>
    <span className="cup__icon" />
  </div>
);
